module.exports = {
    test: {
        title: '다국어 전환 테스트',
        btnTextOne: '중국어',
        btnTextTwo: '영자',
        btnTextThree: '한글',
        content: '현실 생활과 일치: 현실 생활의 절차, 논리와 일치하고 사용자 습관의 언어와 개념을 따른다.인터페이스에서 일치: 모든 요소와 구조는 일치해야 한다. 예를 들어 디자인 스타일, 아이콘과 텍스트, 요소의 위치 등이다.',
    }
}